import React from 'react';

import type { CardDispute } from '@column/api';

/**
 * Placeholder slots for feature components delivered by later dispute parts. Each slot documents
 * the concrete props the feature must implement; Part 02 renders nothing for them so the detail
 * shell stays honest until the real components land.
 *
 * - Part 05 replaces DisputeActionsSlot with response/close forms.
 * - Part 06 replaces DisputeLifecycleGraphSlot with the collaboration/allocation graph.
 * - Part 08 replaces DisputeArbitrationTrackingSlot with filing/ruling tracking.
 */

export interface DisputeFeatureProps {
  dispute: CardDispute;
  canManage: boolean;
  onUpdated: () => void;
}

export interface DisputeLifecycleGraphProps {
  dispute: CardDispute;
  onSelectStage: (stage: CardDispute['stage']) => void;
}

export const DisputeActionsSlot: React.FC<DisputeFeatureProps> = () => null;

export const DisputeArbitrationTrackingSlot: React.FC<DisputeFeatureProps> = () => null;

export const DisputeLifecycleGraphSlot: React.FC<DisputeLifecycleGraphProps> = () => null;

export { DisputeEvidenceComposer as DisputeEvidenceComposerSlot } from './Evidence/DisputeEvidenceComposer';
export type { DisputeEvidenceComposerProps } from './Evidence/DisputeEvidenceComposer';
